import React, { Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import GoogleAnalyticsReporter from '../components/analytics/GoogleAnalyticsReporter'
import AddressClaimModal from '../components/claim/AddressClaimModal'
import Header from '../components/Header'
import Polling from '../components/Header/Polling'
import Popups from '../components/Popups'
import Web3ReactManager from '../components/Web3ReactManager'
import { ApplicationModal } from '../state/application/actions'
import { useModalOpen, useToggleModal } from '../state/application/hooks'
import DarkModeQueryParamReader from '../theme/DarkModeQueryParamReader'
import AddLiquidity from './AddLiquidity'
import {
  RedirectDuplicateTokenIds,
  RedirectOldAddLiquidityPathStructure,
  RedirectToAddLiquidity
} from './AddLiquidity/redirects'
import Earn from './Earn'
import Old from './Earn/Old'
import ManageOld from './Earn/ManageOld'
import Manage from './Earn/Manage'
import Pool from './Pool'
import PoolFinder from './PoolFinder'
import RemoveLiquidity from './RemoveLiquidity'
import { RedirectOldRemoveLiquidityPathStructure } from './RemoveLiquidity/redirects'
import Swap from './Swap'
import Home from './Home'
import Pools from './Pools'
import Coming from './ComingSoon'

import { OpenClaimAddressModalAndRedirectToSwap, RedirectPathToSwapOnly, RedirectToSwap } from './Swap/redirects'

import Vote from './Vote'
import VotePage from './Vote/VotePage'
import ManageLair from './QuickLair/ManageLair'
import { Container } from '@material-ui/core'
import Footer from '../components/Footer'

const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  overflow-x: hidden;
`

const HeaderWrapper = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  width: 100%;
  justify-content: space-between;
`

const FooterWrapper = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  width: 100%;
`

// const BodyWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   width: 100%;
//   /* padding-top: 80px; */
//   align-items: center;
//   flex: 1;
//   overflow-y: auto;
//   overflow-x: hidden;
//   z-index: 10;

//   ${({ theme }) => theme.mediaWidth.upToSmall`
//     // padding: 16px;
//     padding-top: 2rem;
//   `};

//   z-index: 1;
// `

const Marginer = styled.div`
  margin-top: 5rem;
`

function TopLevelModals() {
  const open = useModalOpen(ApplicationModal.ADDRESS_CLAIM)
  const toggle = useToggleModal(ApplicationModal.ADDRESS_CLAIM)
  return <AddressClaimModal isOpen={open} onDismiss={toggle} />
}



export default function App() {
  return (
    <Suspense fallback={null}>
      <Route component={GoogleAnalyticsReporter} />
      <Route component={DarkModeQueryParamReader} />
      {/* <Container maxWidth="xl" style={{height:'100vh'}}>
                <AppWrapper> */}
      {/* <URLWarning /> */}
      {/* <HeaderWrapper>
                    </HeaderWrapper> */}
      {/* <BodyWrapper> */}
      <Popups />
      {/* <Polling /> */}
      <TopLevelModals />
      <Web3ReactManager>
        <Switch>
          <Route exact strict path="/" component={Home} />
          <Route exact strict path="/swap" component={Swap} />
          <Route exact strict path="/pools" component={Pools} />
          <Route exact strict path="/comingGovernance" component={Coming} />
          <Route exact strict path="/comingStaking" component={Coming} />

          <Route exact strict path="/claim" component={OpenClaimAddressModalAndRedirectToSwap} />
          <Route exact strict path="/swap/:outputCurrency" component={RedirectToSwap} />
          <Route exact strict path="/send" component={RedirectPathToSwapOnly} />
          <Route exact strict path="/find" component={PoolFinder} />
          <Route exact strict path="/pool" component={Pool} />
          <Route exact strict path="/quick" component={Earn} />
          <Route exact strict path="/archive" component={Old} />
          <Route exact strict path="/vote" component={Vote} />
          <Route exact strict path="/create" component={RedirectToAddLiquidity} />
          <Route exact path="/add" component={AddLiquidity} />
          <Route exact path="/add/:currencyIdA" component={RedirectOldAddLiquidityPathStructure} />
          <Route exact path="/add/:currencyIdA/:currencyIdB" component={RedirectDuplicateTokenIds} />
          <Route exact path="/create" component={AddLiquidity} />
          <Route exact path="/create/:currencyIdA" component={RedirectOldAddLiquidityPathStructure} />
          <Route exact path="/create/:currencyIdA/:currencyIdB" component={RedirectDuplicateTokenIds} />
          <Route exact strict path="/remove/:tokens" component={RedirectOldRemoveLiquidityPathStructure} />
          <Route exact strict path="/remove/:currencyIdA/:currencyIdB" component={RemoveLiquidity} />
          <Route exact strict path="/quick/:currencyIdA/:currencyIdB/:rewardsAddress" component={Manage} />
          <Route exact strict path="/dquick" component={ManageLair} />
          <Route exact strict path="/archive/:currencyIdA/:currencyIdB/:rewardsAddress" component={ManageOld} />
          <Route exact strict path="/vote/:id" component={VotePage} />
          <Route component={RedirectPathToSwapOnly} />
        </Switch>
      </Web3ReactManager>
      {/* <Marginer /> */}
      {/* </BodyWrapper> */}
      {/* </AppWrapper>
            </Container> */}
      {/* <FooterWrapper>
        <Footer />
      </FooterWrapper> */}
    </Suspense>
  )
}
